import moment from 'moment';
// import * as SemverUtils from './SemverUtils';
import { uniq, isNil } from 'lodash';
import * as Constants from './constants';
import {
  DEFAULT_LINKED_TASK_LIST_TABLE_COLUMN_ORDER,
  DEFAULT_TASK_TABLE_COLUMN_ORDER,
  DEFAULT_USER_MANAGEMENT_TABLE_COLUMN_ORDER,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY,
  RECURRING_TASK_LIST_FILTER_MODEL,
  RECURRING_TASK_LIST_SORT_MODEL,
  LOCAL_STORAGE_RECURRING_TASK_LIST_TABLE_ORDER_KEY,
  LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY,
  LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_USER_MANAGEMENT_TABLE_ORDER_KEY,
  LOCAL_STORAGE_TASK_LIST_FILTER_MODEL,
  LOCAL_STORAGE_TASK_LIST_TEMP_FILTER,
  LOCAL_STORAGE_TASK_LIST_SORT_MODEL,
  LOCAL_STORAGE_FIELD_LIST,
  LOCAL_STORAGE_TASK_PIN_COLUMN_LIST,
  DEFAULT_RECURRING_TASK_TABLE_COLUMN_ORDER,
  USER_LIST_KEY,
} from './AgGridConstants';
import { parseJSONStringToObject } from './UtilityFunctions';

// Anytime the displayed columns or their order is changed, bump the
// npm package version to force a local storage refresh in the client's
// task table settings
const LOCAL_STORAGE_RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL = 'RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL';
const LOCAL_STORAGE_LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL = 'LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL';
const SET_SELECTED_FIELD_LOCAL_STORAGE = 'selectedField';
const SET_FINAL_CENTER_ZOOM_MAP_VIEW = 'SET_FINAL_CENTER_ZOOM_MAP_VIEW';
const SELECTED_AREAS_LOCAL_STORAGE = 'selectedAreas';
const SELECTED_TASKTYPE_GROUPS_LOCAL_STORAGE = 'selectedTaskTypeGroups';

// function checkAppVersion() {
//   const version = process.env.REACT_APP_VERSION;
//   const localStorageAppVersion = localStorage.getItem(Constants.LOCAL_STORAGE_ADMIN_UI_VERSION);
//   if (!localStorageAppVersion || SemverUtils.atLeastMinorVersionUpgrade(localStorageAppVersion, version)) {
//     [
//       LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY,
//       LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY,
//       LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY,
//       LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_VISIBILITY_KEY,
//       LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_WIDTH_KEY,
//       LOCAL_STORAGE_USER_MANAGEMENT_TABLE_ORDER_KEY,
//       LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY,
//       LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY,
//       LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY,
//       LOCAL_STORAGE_RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL,
//       LOCAL_STORAGE_LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL,
//       LOCAL_STORAGE_TASK_LIST_FILTER_MODEL,
//       LOCAL_STORAGE_TASK_LIST_SORT_MODEL,
//       LOCAL_STORAGE_FIELD_LIST,
//     ].forEach((key) => {
//       localStorage.removeItem(key);
//     });
//     localStorage.setItem(Constants.LOCAL_STORAGE_ADMIN_UI_VERSION, version);
//   }
// }
function getKeyValueFromUserConfigOrLocalStorage(viewConfigObj = {}, key, defaultValue) {
  let value;
  if (viewConfigObj?.[key]) {
    value = viewConfigObj?.[key];
  } else {
    value = localStorage.getItem(key);
  }

  if (value) {
    if (typeof value === 'string') {
      value = JSON.parse(value);
    }
    return value;
  }

  return defaultValue;
}
export function getTaskListTableProperties(userConfig) {
  // checkAppVersion();
  const { TASK_LIST } = userConfig || {};

  const columnOrder = getKeyValueFromUserConfigOrLocalStorage(
    TASK_LIST,
    LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY,
    DEFAULT_TASK_TABLE_COLUMN_ORDER
  );

  const columnVisibility = getKeyValueFromUserConfigOrLocalStorage(
    TASK_LIST,
    LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY,
    {}
  );

  const columnWidth = getKeyValueFromUserConfigOrLocalStorage(TASK_LIST, LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY, {});

  const filter = getKeyValueFromUserConfigOrLocalStorage(TASK_LIST, LOCAL_STORAGE_TASK_LIST_FILTER_MODEL, {});

  const sortModel = getKeyValueFromUserConfigOrLocalStorage(TASK_LIST, LOCAL_STORAGE_TASK_LIST_SORT_MODEL, []);

  const pinnedColumnsMap = getKeyValueFromUserConfigOrLocalStorage(TASK_LIST, LOCAL_STORAGE_TASK_PIN_COLUMN_LIST, {});

  return { columnOrder: uniq(columnOrder), columnVisibility, columnWidth, filter, sortModel, pinnedColumnsMap };
}

export function getRecurringTaskListTableProperties(userConfig) {
  // checkAppVersion();
  const { RECURRING_TASK_LIST } = userConfig || {};

  const columnOrder = getKeyValueFromUserConfigOrLocalStorage(
    RECURRING_TASK_LIST,
    LOCAL_STORAGE_RECURRING_TASK_LIST_TABLE_ORDER_KEY,
    DEFAULT_RECURRING_TASK_TABLE_COLUMN_ORDER
  );

  const columnVisibility = getKeyValueFromUserConfigOrLocalStorage(
    RECURRING_TASK_LIST,
    LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_VISIBILITY_KEY,
    {}
  );

  const columnWidth = getKeyValueFromUserConfigOrLocalStorage(
    RECURRING_TASK_LIST,
    LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY,
    {}
  );

  const filter = getKeyValueFromUserConfigOrLocalStorage(RECURRING_TASK_LIST, RECURRING_TASK_LIST_FILTER_MODEL, {});

  const sortModel = getKeyValueFromUserConfigOrLocalStorage(RECURRING_TASK_LIST, RECURRING_TASK_LIST_SORT_MODEL, []);

  return { columnOrder: uniq(columnOrder), columnVisibility, columnWidth, filter, sortModel };
}

export function getUserManagementTableProperties(columnMap, userConfig) {
  const userListConfig = userConfig?.[USER_LIST_KEY] ?? {};
  let columnOrder = JSON.parse(userListConfig?.[LOCAL_STORAGE_USER_MANAGEMENT_TABLE_ORDER_KEY] ?? '[]');
  const columnVisibility = JSON.parse(
    userListConfig?.[LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_VISIBILITY_KEY] ?? '{}'
  );
  const columnWidth = JSON.parse(userListConfig?.[LOCAL_STORAGE_USER_MANAGEMENT_TABLE_COLUMN_WIDTH_KEY] ?? '{}');
  if (Object.keys(columnVisibility)?.length === 0) {
    return Object.values(columnMap);
  }
  if (columnOrder.length === 0) {
    columnOrder = DEFAULT_USER_MANAGEMENT_TABLE_COLUMN_ORDER;
  }

  Object.keys(columnMap).forEach((key) => {
    if (!isNil(columnVisibility) && !isNil(columnVisibility[key])) {
      columnMap[key].hide = !columnVisibility[key];
    }
  });

  for (const [field, column] of Object.entries(columnMap)) {
    if (columnWidth[field]) {
      Object.assign(column, { width: columnWidth[field] });
    }
  }
  const columnDefs = columnOrder.map((columnKey) => columnMap[columnKey]).filter((col) => !!col);
  return columnDefs;
}

export function getLinkedTaskListTableProperties() {
  // checkAppVersion();

  const columnOrder = localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY))
    : DEFAULT_LINKED_TASK_LIST_TABLE_COLUMN_ORDER;
  const columnVisibility = localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY))
    : {};
  const columnWidth = localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY))
    : {};

  return { columnOrder, columnVisibility, columnWidth };
}

export function setDateRange(startDate, endDate) {
  const currDate = moment().format(Constants.GRIDS_DATE_DISPLAY_FORMAT);
  if (currDate === startDate || currDate === endDate) {
    localStorage.setItem(Constants.LOCAL_STORAGE_SELECTED_DATE_RANGE, JSON.stringify({ startDate, endDate }));
  }
}

export function getDateRange() {
  const currentDate = moment().format(Constants.GRIDS_DATE_DISPLAY_FORMAT);
  let dateRange =
    localStorage.getItem(Constants.LOCAL_STORAGE_SELECTED_DATE_RANGE) &&
    JSON.parse(localStorage.getItem(Constants.LOCAL_STORAGE_SELECTED_DATE_RANGE));
  if (!dateRange || !(dateRange.endDate === currentDate || dateRange.startDate === currentDate)) {
    const endDate = currentDate;
    const startDate = currentDate;
    dateRange = {
      endDate,
      startDate,
    };
    setDateRange(startDate, endDate);
  }
  return dateRange;
}

export function getResourceSchedulerViewZoomLevel() {
  // checkAppVersion();
  const zoomLevel = localStorage.getItem(LOCAL_STORAGE_RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL)
    ? parseInt(localStorage.getItem(LOCAL_STORAGE_RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL))
    : 0;
  return zoomLevel;
}

export function setResourceSchedulerViewZoomLevel(zoomLevel) {
  localStorage.setItem(LOCAL_STORAGE_RESOURCE_SCHEDULER_VIEW_ZOOM_LEVEL, zoomLevel);
}

export function getLocationSchedulerViewZoomLevel() {
  // checkAppVersion();
  const zoomLevel = localStorage.getItem(LOCAL_STORAGE_LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL)
    ? parseInt(localStorage.getItem(LOCAL_STORAGE_LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL))
    : 0;
  return zoomLevel;
}

export function setLocationSchedulerViewZoomLevel(zoomLevel) {
  localStorage.setItem(LOCAL_STORAGE_LOCATION_SCHEDULER_VIEW_ZOOM_LEVEL, zoomLevel);
}

export const getFilterFromLocalStorage = () => {
  const temp = localStorage.getItem(LOCAL_STORAGE_TASK_LIST_FILTER_MODEL)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_TASK_LIST_FILTER_MODEL))
    : {};
  return temp;
};

export const getTempFilterFromLocalStorage = () => {
  const testing = localStorage.getItem(LOCAL_STORAGE_TASK_LIST_TEMP_FILTER)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_TASK_LIST_TEMP_FILTER))
    : {};

  return testing;
};

export const getFieldFilterFromLocalStorage = () => {
  const { id, name } = localStorage.getItem(LOCAL_STORAGE_FIELD_LIST)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_FIELD_LIST))
    : {};
  return { id, name };
};

export const setSelectedFieldInLocalStorage = (fieldId) => {
  return localStorage.setItem(SET_SELECTED_FIELD_LOCAL_STORAGE, fieldId);
};

export const getSelectedFieldInLocalStorage = () => {
  return localStorage.getItem(SET_SELECTED_FIELD_LOCAL_STORAGE);
};

export const setFinalCenterAndZoomInMapView = (centerAndZoom) => {
  if (centerAndZoom) {
    localStorage.setItem(SET_FINAL_CENTER_ZOOM_MAP_VIEW, JSON.stringify(centerAndZoom));
  } else {
    localStorage.removeItem(SET_FINAL_CENTER_ZOOM_MAP_VIEW);
  }
};

export const getFinalCenterAndZoomInMapView = () => {
  const centerAndZoom = localStorage.getItem(SET_FINAL_CENTER_ZOOM_MAP_VIEW);
  if (centerAndZoom) {
    return parseJSONStringToObject(centerAndZoom);
  }
  return null;
};

export const setSelectedAreasInLocalStorage = (areaIds) => {
  return localStorage.setItem(SELECTED_AREAS_LOCAL_STORAGE, JSON.stringify(areaIds));
};

export const getSelectedAreasInLocalStorage = () => {
  const temp = localStorage.getItem(SELECTED_AREAS_LOCAL_STORAGE);
  return temp ? JSON.parse(temp) : [];
};

export const setSelectedTaskTypeGroupsInLocalStorage = (taskTypeGroupIds) => {
  return localStorage.setItem(SELECTED_TASKTYPE_GROUPS_LOCAL_STORAGE, JSON.stringify(taskTypeGroupIds));
};

export const getSelectedTaskTypeGroupsInLocalStorage = () => {
  const temp = localStorage.getItem(SELECTED_TASKTYPE_GROUPS_LOCAL_STORAGE);
  return temp ? JSON.parse(temp) : [];
};

export const makeInitialUserConfig = (userId, tenantId) => {
  return {
    userId,
    tenantId,
    TASK_LIST: {
      TASK_LIST_TABLE_ORDER_KEY:
        localStorage.getItem(LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY) ||
        JSON.stringify(DEFAULT_TASK_TABLE_COLUMN_ORDER),
      TASK_TABLE_COLUMN_WIDTH_KEY:
        localStorage.getItem(LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY) || JSON.stringify({}),
      TASK_LIST_FILTER_MODEL: localStorage.getItem(LOCAL_STORAGE_TASK_LIST_FILTER_MODEL) || JSON.stringify({}),
      TASK_LIST_SORT_MODEL: localStorage.getItem(LOCAL_STORAGE_TASK_LIST_SORT_MODEL) || JSON.stringify({}),
      TASK_PIN_COLUMN_LIST: localStorage.getItem(LOCAL_STORAGE_TASK_PIN_COLUMN_LIST) || JSON.stringify({}),
      TASK_TABLE_COLUMN_VISIBILITY_KEY:
        localStorage.getItem(LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY) || JSON.stringify({}),
    },
  };
};

const ACTION_RECORD = 'actionRecord';

export const actionRecordUtils = {
  GET_ACTION_RECORD: () =>
    sessionStorage.getItem(ACTION_RECORD) ? JSON.parse(sessionStorage.getItem(ACTION_RECORD)) : null,
  SET_ACTION_RECORD: (actionRecord) => sessionStorage.setItem(ACTION_RECORD, JSON.stringify(actionRecord)),
  REMOVE_ACTION_RECORD: () => sessionStorage.removeItem(ACTION_RECORD),
};
